import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
} from 'react';

interface AcademicYearContextType {
  selectedYear: number | null;
  setSelectedYear: (year: number | null) => void;
}

const AcademicYearContext = createContext<AcademicYearContextType | undefined>(undefined);

export const AcademicYearProvider = ({ children }: { children: ReactNode }) => {
  const [selectedYear, setSelectedYear] = useState<number | null>(new Date().getFullYear());

  return (
    <AcademicYearContext.Provider value={{ selectedYear, setSelectedYear }}>
      {children}
    </AcademicYearContext.Provider>
  );
};

export const useAcademicYear = () => {
  const context = useContext(AcademicYearContext);
  if (context === undefined) {
    throw new Error('useAcademicYear must be used within an AcademicYearProvider');
  }
  return context;
};
